import React, { useEffect, useState } from 'react'
import OpenStreetView from '../../Maps/component/OpenStreetView'
import { Checkbox } from '@mui/material'
import { apiService } from '../../../../constant/AuthConstant'
import useExit from '../../../../utils/useExit'
import returnError from '../../../../utils/ExportError'
import { enqueueSnackbar } from 'notistack'
import GallaryDesignOne from '../Gallary/GallaryDesignOne'

const GallaryTemplateOne = ({
    label,
    gallaryItem,
    selectedGallary,
    isSubmitting,
    updateSelectedMapTemplate
}) => {
    return (
        <div>
            <div
            className='mb-6 p-2 flex justify-between items-center'
            style={{
                borderRadius: '4px',
                backgroundColor: 'white',
                color: '#353349',
                width: '350px',
                height: 'auto',
                border: '2px solid #E1EBFE',
                fontWeight: 400,
            }}
            >
                {label}
                <div>
                   <Checkbox 
                     disabled={true} 
                     checked={selectedGallary === gallaryItem?.value} 
                     onChange={(e)=>{
                        e.preventDefault()
                        updateSelectedMapTemplate(gallaryItem?.value)
                    }}/>
                </div>
            </div>
            <GallaryDesignOne />
        </div>
    )
}
const GallaryTemplates = ({
    organization
}) =>{
    const { exitFromPlatform } = useExit()
    const [loading, setLoading] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [selectedGallary, setSelectedGallary] = useState('gallary_template_1')

    const templates = [
        {id: 1, label: 'Gallary Template 1', component: GallaryTemplateOne, value:"gallary_template_1" },
    ];


    const updateSelectedGallaryTemplate = (value) =>{
        setIsSubmitting(true)
        apiService.put(`organization/gallary-template/`, { 
            template: value, 
            org: organization?.id
        }).then((response) =>{
            if(response){
                setSelectedGallary(response?.data?.template)
            }
            setIsSubmitting(false)
        }).catch((error) =>{
            if(error.response?.data){
                const returnedError = returnError(error.response?.data)
                if(returnedError === 'Given token not valid for any token type' || returnedError === 'Request failed with status code 401'){
                    exitFromPlatform()
                }else{
                    enqueueSnackbar(returnedError, {variant:'error'})
                    setIsSubmitting(false)
                }
            }
        })
    }
    return(
        <div className='my-6 max-h-[60vh] overflow-y-scroll'>
             {templates?.map((spec) =>{
                return (
                    <spec.component
                        key={spec.id}
                        mapItem={spec}
                        label={spec?.label} 
                        selectedMap={selectedGallary}
                        isSubmitting={isSubmitting}
                        updateSelectedMapTemplate={updateSelectedGallaryTemplate}
                    />
                )
             })}
        </div>
    )
}

export default GallaryTemplates